document.querySelectorAll('.sticky-add-to-cart').forEach((bar) => {
  const targetButtonId = bar.dataset.targetButton;
  const targetPriceId = bar.dataset.targetPrice;
  const realButton = document.getElementById(targetButtonId);
  const realPrice = document.getElementById(targetPriceId);
  const stickyButton = bar.querySelector('.sticky-add-to-cart__button');
  const stickyPrice = bar.querySelector('.sticky-add-to-cart__price');
  if (!realButton || !stickyButton) return;

  const syncFromRealButton = () => {
    const disabled = realButton.hasAttribute('disabled');
    stickyButton.toggleAttribute('disabled', disabled);
    const label = realButton.querySelector('span')?.textContent;
    const stickyLabel = stickyButton.querySelector('span');
    if (label && stickyLabel) stickyLabel.textContent = label.trim();
  };

  const syncPrice = () => {
    if (realPrice && stickyPrice) {
      stickyPrice.innerHTML = realPrice.innerHTML;
    }
  };

  stickyButton.addEventListener('click', () => {
    if (stickyButton.hasAttribute('disabled')) return;
    realButton.click();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      syncFromRealButton();
      syncPrice();
    });
  }

  // Fallback: also observe attribute changes directly, in case variantChange
  // isn't published for every relevant update path.
  new MutationObserver(syncFromRealButton).observe(realButton, { attributes: true, attributeFilter: ['disabled'] });
  if (realPrice) {
    new MutationObserver(syncPrice).observe(realPrice, { childList: true, subtree: true });
  }

  const formRoot = realButton.closest('product-form') || realButton.closest('.product-form__buttons');
  if (formRoot && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.hidden = entry.isIntersecting;
        });
      },
      { threshold: 0 }
    );
    observer.observe(formRoot);
  }
});
